import React, {CSSProperties, ReactElement} from "react";
import clsx from "clsx";
import classes from './Button.module.scss'

interface Props {
	label?: string,
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
	type?: "submit" | "reset",
	className?: string,
	style?: CSSProperties,
	disabled?:boolean
}

const Button = (props: Props): ReactElement<Props> => {
	return (
		<button
			className={clsx(
				classes.button,
				props.className
			)}
			style={props.style}
			onClick={props.onClick}
			type={props.type}
			disabled={props.disabled}
		>
			{props.label}
		</button>
	)
}

export default Button